import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import ToolHub from './pages/ToolHub';
import EmergencyContactApp from './pages/EmergencyContactApp';
import MaintenanceApp from './pages/MaintenanceApp';
import DebtManagementTest from './pages/DebtManagementTest';
import BudgetTool from './pages/BudgetTool';
import InventoryTool from './pages/InventoryTool';
import EmergencyPlanTool from './pages/EmergencyPlanTool';
import BinderHub from './pages/BinderHub';
import DocumentsTool from './pages/DocumentsTool';
import MapIndexTool from './pages/MapIndexTool';
import FinancialSummaryTool from './pages/FinancialSummaryTool';
import ValuablesTool from './pages/ValuablesTool';
import BabysitterReferenceTool from './pages/BabysitterReferenceTool';
import AdminLogin from './pages/AdminLogin';
import AdminRiskReport from './pages/AdminRiskReport';
import AdminRoute from './components/AdminRoute';
import ErrorBoundary from './components/ErrorBoundary';
import { Toaster } from 'sonner';

// Scroll to top on every route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const location = useLocation();

  // Hide navigation on tool hub homepage for cleaner look
  const showNavigation = location.pathname !== '/';

  return (
    <div className="min-h-screen bg-page">
      {showNavigation && <Navigation />}

      <ScrollToTop />
      <main className={showNavigation ? 'pt-0' : ''}>
        <Routes>
          <Route path="/" element={<ToolHub />} />
          <Route path="/emergency" element={<EmergencyContactApp />} />
          <Route path="/maintenance" element={<MaintenanceApp />} />
          <Route path="/debt-test" element={<DebtManagementTest />} />
          <Route path="/budget" element={<BudgetTool />} />
          <Route path="/inventory" element={<InventoryTool />} />
          <Route
            path="/emergency-plan"
            element={
              <ErrorBoundary>
                <EmergencyPlanTool />
              </ErrorBoundary>
            }
          />
          <Route path="/binder-hub" element={<BinderHub />} />
          <Route path="/documents" element={<DocumentsTool />} />
          <Route path="/map-index" element={<MapIndexTool />} />
          <Route path="/financial-summary" element={<FinancialSummaryTool />} />
          <Route path="/valuables" element={<ValuablesTool />} />
          <Route path="/babysitter-reference" element={<BabysitterReferenceTool />} />
          {/* Admin routes - not linked in Navigation */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/risk-report"
            element={
              <AdminRoute>
                <AdminRiskReport />
              </AdminRoute>
            }
          />
          <Route path="*" element={<ToolHub />} />
        </Routes>
      </main>

      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
